import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Subject, tap, takeUntil } from 'rxjs';
import { UserService } from '../../services/user.service';
import { autoCompleteRequired } from '../../validators/autocompleteRequired';
import { CustomerAccountService } from '../../services/users/customer-account.service';

@Component({
  selector: 'app-customers-dropdown',
  templateUrl: './customers-dropdown.component.html',
  styleUrl: './customers-dropdown.component.scss'
})
export class CustomersDropdownComponent {

  _unsubscribe$: Subject<boolean> = new Subject()

  form = this.fb.group({
    Id: ['', [autoCompleteRequired()]],
  })

  @Input() label:string = "Common.UserId"
  @Input() dataSource:any[]|any = null
  @Input() haveParent:boolean|null = null
  @Input() userType:number[]|null = null
  @Input() isRequired:boolean = false
  @Input() isAdminPage:boolean = false
  @Output() updateParent: EventEmitter<any> = new EventEmitter();

  timeOut:any=0

  constructor(
    private customerAccountService: CustomerAccountService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    if(!this.dataSource){
      this.getData()
    }
    if(this.isRequired){
      this.form.get('Id')?.addValidators(Validators.required)
    }
  }

  /*----------------------Functions Called from parent---------------------- */
  // setValue(data){
  //   // console.log("eventdata",data)
  //   this.userVal = `[${data.Service_Id}] - ${data.Service_Id}`;
  // }

  reset(){
    this.form.reset()
    this.updateParent.emit("");
  }

  /*----------------------Getting Users for dropdown select---------------------- */

  onType(value: string) {
    if (value.length == 0 || value.length > 1) {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        this.dataSource=[]
        this.getData(value)
      }, 1000)
    }
  }

  getData(searchValue:string='') {
    let body :any= {
      pageNo: 1,
      pageSize: 50,
      isAll: false,
      userType:this.userType ? this.userType : null,     
      searchString:searchValue
    }
    if(this.haveParent){
     body={...body, haveParent: true}
    }
    let api = this.isAdminPage ? this.customerAccountService.GetCustomersAdmin(body) : this.customerAccountService.GetCustomers(body)
     api.pipe(
      tap(
        (result) => {
          if(result.IsSuccess && result.Data){
            this.dataSource = result.Data;
          }
        }
      ),
      takeUntil(this._unsubscribe$),
    )
    .subscribe();
  }


  /*----------------------when Choosing User---------------------- */
  changeSelected(selectedValue:any){ 
    if(selectedValue){
      let Id= (this.form.get('Id')?.value as any).Id
      this.updateParent.emit(Id);   
    }else{
      this.updateParent.emit("");   
    }
  }

  displayFn(item:any) {
    if (!item) return '';
    let index = this.dataSource.findIndex((e:any) => e.Id == item.Id);
    return `${this.dataSource[index].User.UserFullName}`;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next(true)
    this._unsubscribe$.complete()
  }
}
